export default "__VITE_ASSET__3JfZ34fc__"